import * as yup from "yup";

export const signInFields = [
  {
    name: "email",
    type: "email",
    placeholder: "EMAIL",
  },
  {
    name: "password",
    type: "password",
    placeholder: "PASSWORD",
  },
];

export const validationSchema = () =>
  yup.object().shape({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    password: yup.string().required("Password is required").min(8),
  });
